import * as Yup from 'yup';
import { setLocale } from 'yup';

setLocale({
    mixed: {
        required: ({ fieldName }) => ({ key: 'formValidation.field_required', values: { fieldName } })
    },
    string: {
        min: ({ min }) => ({ key: 'formValidation.field_too_short', values: { min } }),
        max: ({ max }) => ({ key: 'formValidation.field_too_big', values: { max } }),
        email: 'formValidation.field_mail_invalid',
        matches: 'formValidation.field_format_invalid',
        required: 'formValidation.field_required'
    },
    number: {
        min: ({ min }) => ({ key: 'formValidation.number_field_too_short', values: { min } }),
        max: ({ max }) => ({ key: 'formValidation.number_field_too_big', values: { max } }),
    },
    date: {
        min: ({ min }) => ({ key: 'formValidation.date_gt', values: { min } }),
        max: ({ max }) => ({ key: 'formValidation.date_lt', values: { max } }),
    },
});


export const getSignSchema = () => {
    return Yup.object().shape({
        password: Yup.string().nullable().required()
    });
}

export const getSignaturePasswordSchema = () => {
    return Yup.object().shape({
        newSignaturePassword: Yup.string()
            .required('La contraseña es obligatoria')
            .min(8, 'Debe tener al menos 8 caracteres')
            .matches(/[A-Z]/, 'Debe contener al menos una letra mayúscula')
            .matches(/[0-9]/, 'Debe contener al menos un número')
            .matches(/[!@#$%^&*(),.?":{}|<>_\-]/, 'Debe contener al menos un caracter especial'),
    });
}